import type { Database } from '../lib/adatbazis.ts';

export type HibajegyStatusz = Database['public']['Enums']['hibajegy_statusz'];
export type HibajegyPrioritas = Database['public']['Enums']['hibajegy_prioritas'];
export type HibajegySor = Database['public']['Tables']['hibajegyek']['Row'];
export type HibajegyUzenet = Database['public']['Tables']['hibajegy_uzenetek']['Row'];
export type HibajegyKep = Database['public']['Tables']['hibajegy_kepek']['Row'];

export const HIBAJEGY_STATUSZ_CIMKE: Record<HibajegyStatusz, string> = {
  bekuldve: 'Beküldve',
  javitas_alatt: 'Javítás alatt',
  kesz: 'Kész',
  elutasitva: 'Elutasítva',
  uj_fejlesztes: 'Új fejlesztés',
};

export const PRIORITAS_CIMKE: Record<HibajegyPrioritas, string> = { raer: 'Ráér', normal: 'Normál', surgos: 'Sürgős' };
export const PRIORITAS_SORREND: HibajegyPrioritas[] = ['raer', 'normal', 'surgos'];

/** Nyitott állapotok; minden más lezárt, és véglegesen az marad. */
const NYITOTT: ReadonlySet<HibajegyStatusz> = new Set(['bekuldve', 'javitas_alatt']);

export function nyitott(statusz: HibajegyStatusz): boolean {
  return NYITOTT.has(statusz);
}

/** Az aktuális állapotból engedett következő állapotok (a super admin léptető gombjai; az állapot-guard a szerveren is ellenőriz). */
export function engedettAtmenetek(statusz: HibajegyStatusz): HibajegyStatusz[] {
  if (statusz === 'bekuldve') return ['javitas_alatt', 'kesz', 'elutasitva', 'uj_fejlesztes'];
  if (statusz === 'javitas_alatt') return ['kesz', 'elutasitva', 'uj_fejlesztes'];
  return [];
}

/** Az elutasításhoz indoklás kell; a többi átmenethez a megjegyzés nem kötelező. */
export function atmenetHiba(cel: HibajegyStatusz, megjegyzes: string): string | null {
  if (cel === 'elutasitva' && megjegyzes.trim() === '') return 'Az elutasításhoz írj indoklást.';
  return null;
}

export type SzuroAllapot = 'nyitott' | 'lezart' | 'mind';

export function szuroIllik(szuro: SzuroAllapot, statusz: HibajegyStatusz): boolean {
  return szuro === 'mind' || (szuro === 'nyitott') === nyitott(statusz);
}

export function szuroErtek(nyers: string | null): SzuroAllapot {
  return nyers === 'lezart' || nyers === 'mind' ? nyers : 'nyitott';
}

export const CIM_MAX = 150;
export const LEIRAS_MAX = 5000;

export function urlapHiba(cim: string, leiras: string): string | null {
  if (cim.trim() === '') return 'Add meg a hiba címét.';
  if (cim.trim().length > CIM_MAX) return `A cím legfeljebb ${CIM_MAX} karakter lehet.`;
  if (leiras.trim() === '') return 'Írd le, mi történt.';
  if (leiras.trim().length > LEIRAS_MAX) return `A leírás legfeljebb ${LEIRAS_MAX} karakter lehet.`;
  return null;
}

/** A jelenlegi oldal elérési útja az űrlap „Oldal” mezőjéhez (a lekérdezés-paramétereket nem visszük el, mert azokban személyes adat lehet). */
export function oldalUrl(pathname: string, origin: string): string {
  return `${origin}${pathname}`.slice(0, 500);
}
